import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "How can I pay monthly for travel, education, and healthcare in UAE?",
    answer: "Flexaura lets you pay monthly for life's major milestones including travel packages, education courses, and healthcare treatments. We partner with licensed BNPL providers, banks, and finance companies to offer flexible payment options from AED 2,000 to 200,000+."
  },
  {
    question: "What is BNPL for travel, education, and healthcare?", 
    answer: "Buy Now Pay Later (BNPL) allows you to purchase travel packages, education courses, or healthcare treatments and split the cost into manageable monthly installments. You get your service immediately while paying over time."
  },
  {
    question: "Is Flexaura a lender or bank?",
    answer: "No, Flexaura is a comparison marketplace for monthly payment options. All financing is provided by our licensed partners including Emirates NBD, FAB, ADCB, Tabby, Tamara, and other regulated financial institutions in UAE."
  },
  {
    question: "What's the financing range for monthly payments?", 
    answer: "Our partners offer monthly payment plans from AED 2,000 to AED 200,000+, depending on eligibility and approval. Different payment options are available based on the purchase amount."
  },
  {
    question: "Do I need a credit card for monthly payment plans?",
    answer: "It depends on the payment option you choose. Some BNPL providers don't require a credit card, while bank installment plans typically do. We show you all available options during checkout."
  },
  {
    question: "Are there fees for paying monthly?",
    answer: "All fees and interest rates are shown upfront before you choose a payment plan. Fees vary by partner and payment option - some BNPL options have zero interest if paid on time."
  },
  {
    question: "Is my personal and financial data secure?",
    answer: "Yes, we use bank-level encryption and only share necessary information with our licensed financial partners for eligibility assessment. We comply with UAE data protection regulations."
  },
  {
    question: "When will Flexaura launch for monthly payments?",
    answer: "We're launching soon! Join our waitlist to get early access to monthly payment options for travel, education, and healthcare purchases."
  }
];

const FAQSection = () => {
  return (
    <section className="py-20 px-4 bg-background" id="faq" data-section="faq">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold mb-4 text-primary">
            Pay Monthly FAQ - Travel, Education & Healthcare
          </h2>
          <p className="text-lg text-muted-foreground font-body">
            Everything you need to know about paying monthly for life's milestones with Flexaura BNPL
          </p>
        </div>
        
        <div className="bg-card rounded-2xl p-6 card-shadow">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left font-heading font-semibold hover:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-body">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
